import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridGap: `${styles.spacing(4)}px`,
    marginBottom: `${styles.spacing(6)}px`,
    [styles.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  text: {
    display: 'flex',
    alignItems: 'center',
  },
  visuals: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imgLink: {
    display: 'block',
    marginBottom: `${styles.spacing(4)}px`,
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
});
